require('./passStep2.scss');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @ components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')
const { FormattedIban } = require('commonsComponents/formattedIban');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

// @ constants
const { FIRST_STEP, EURO_TEXT, EMPTY_CONCEPT, API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
const { PASS_MONEY_ID } = require('constants/operationTypes');


class PassStep2 extends React.Component {
    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildAccountItem(account, title) {
        if (account) {
            const accountAlias = account.get('alias') || toCamelCase(account.get('accountType'));
            const accountIban = account.get('iban');

            return (
                <OKInformativeListItem
                    title={title}
                    bodyText={accountAlias}
                >
                    <FormattedText value="passStep2-iban" format="uppercase" className="pass-step-2__iban-label" />
                    <FormattedIban iban={accountIban} />
                </OKInformativeListItem>
            );
        }
    }

    buildSummaryContent() {
        const { originAccount, destinationAccount } = this.props;
        const firstStep = this.props.immPassState.getIn(['steps', FIRST_STEP]);
        const originAccountItem = this.buildAccountItem(originAccount, formatText('passStep2-origin'));
        const concept  = firstStep.get('concept') || EMPTY_CONCEPT;
        const destinationAccountItem = this.buildAccountItem(destinationAccount, formatText('passStep2-destination'));
        const amountObject = {
            amount: firstStep.get('amount'),
            currency: firstStep.get('fromAccountCurrency') || EURO_TEXT
        };
        const plainAmountObject = getPlainAmountObject(amountObject);

        return (
            <OKInformativeList columns={2}>
                {originAccountItem}
                <OKInformativeListItem
                    title="passStep2-concept"
                    bodyText={concept}
                />
                {destinationAccountItem}
                <OKInformativeListItem title="passStep2-import">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        className="pass-step-2__amount"
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}/>
                </OKInformativeListItem>
            </OKInformativeList>
        );
    }

    render() {
        const { originAccount, destinationAccount, immPassState, signaturePatternRequired } = this.props;
        const firstStep = immPassState.getIn(['steps', FIRST_STEP]);
        const summaryContent = this.buildSummaryContent();
        const operative = formatText('operatives-transferBetweenAccounts');
        const signaturePatternContainerClasses = classnames({ 'pass-step-2__signature-pattern-hidden': !signaturePatternRequired });
        const confirmationTitleClassName = contactCenterClassName('print-title', 'pass-step-2__header');

        const operationParams = {
          'ammount': firstStep.get('amount'),
          'currency': EURO_TEXT,
          'originAccount': `${API_ENTERPRISE_NUMBER}${API_CENTER}${originAccount.get('newProduct')}${originAccount.get('newContractNumber')}`,
          'destinationAccount': destinationAccount.get('iban')
        };        

        return (
            <article className="pass-step-2">
                <section>
                    <header className={confirmationTitleClassName}>
                        <FormattedText value="passStep2-confirmation" />
                    </header>

                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    
                    <section className="pass-step-2__content">
                        <FormattedText id="txt_PassStep2_Title" value="passStep2-passSummary" className="pass-step-2__subtitle"/>
                        {summaryContent}
                    </section>
                </section>
                <section>

                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>

                    <div className={signaturePatternContainerClasses}>
                        <WebappRender>
                            <header className="pass-step-2__header">
                                <FormattedText id="txt_PassStep2_Title" value="signaturePattern-title" />
                            </header>
                        </WebappRender>

                        <SignaturePattern
                            operationType={PASS_MONEY_ID}
                            operationParams={operationParams}
                        />
                    </div>
                </section>
            </article>
        );
    }
}

PassStep2.propTypes = {
    originAccount: PropTypes.object,
    destinationAccount: PropTypes.object,
    immPassState: PropTypes.object,
    actions: PropTypes.object,
    signaturePatternRequired: PropTypes.bool.isRequired
};

module.exports = PassStep2;
